/**
 * Rücksprung-Ziel nach der Anmeldung (z. B. kochen.symbolbuch.de).
 * Nur https-Adressen unter symbolbuch.de sind erlaubt – kein offener Redirect.
 */
export function safeReturnTo(search: string): string | null {
  const raw = new URLSearchParams(search).get('returnTo');
  if (!raw) return null;
  try {
    const url = new URL(raw);
    const host = url.hostname.toLowerCase();
    if (url.protocol !== 'https:') return null;
    if (url.username || url.password || url.port) return null;
    if (host !== 'symbolbuch.de' && !host.endsWith('.symbolbuch.de')) return null;
    return url.href;
  } catch {
    return null;
  }
}
